import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

const backgroundless = (theme) =>
    theme.ChoiceListBackgroundAlpha === 0 && theme.ChoiceListBackgroundBorderWidth === 0;

export default createUseStyles({
    choice: {
        background: ({ theme }) =>
            Mixins.alpha(theme.ControlBackground, theme.ChoiceListBackgroundAlpha),
        borderRadius: ({ theme }) =>
            Math.min(theme.ChoiceListBackgroundBorderRadius, theme.ChoiceHeight / 2),
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.ChoiceListBackgroundBorderWidth}px ${theme.ControlBorderColor} inset`,
        boxSizing: "border-box",
        color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.controlBackgroundColor(theme)),
        composes: "choice",
        cursor: "pointer",
        margin: ({ theme }) => (backgroundless(theme) ? [[0, -13]] : [[theme.ChoiceSpacing, 0]]),
        outline: "2px solid transparent",
        overflow: "hidden",
        padding: ({ theme }) => (backgroundless(theme) ? [[16, 13]] : [[16, 26]]),
        textAlign: ({ theme }) => (theme.DisplayChoiceIcon === "right" ? "right" : ""),
        transition: "background 200ms, box-shadow 200ms, outline-color 200ms",
        userSelect: "none",
        "& .check-box__icon": {
            display: ({ theme }) => (!theme.ShowCheckboxSettings ? "none" : ""),
        },
        "& .radio__icon": {
            display: ({ theme }) => (!theme.ShowRadioSettings ? "none" : ""),
        },
    },
    choiceHeader: {
        composes: "choice__header",
        fontWeight: 700,
        margin: ({ theme }) => [[theme.ChoiceSpacing, 0]],
    },
    choiceText: {
        composes: "choice__text",
        fontWeight: 700,
        marginLeft: 8,
        paddingLeft: 20,
    },
    choiceContainer: {
        alignItems: "center",
        composes: "choice-container",
        display: "flex",
        flex: 1,
        flexDirection: ({ theme }) => (theme.DisplayChoiceIcon === "right" ? "row-reverse" : "row"),
        "& .check-box__icon": {
            flexDirection: ({ theme }) =>
                theme.CheckBoxIconAlignment === "right" ? "row-reverse" : "row",
        },
        "& .radio__icon": {
            flexDirection: ({ theme }) =>
                theme.RadioIconAlignment === "right" ? "row-reverse" : "row",
        },
    },
    choiceSelected: {
        background: ({ theme }) => !backgroundless(theme) && theme.PrimaryColor,
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.BorderWidth}px ${Mixins.borderColor(theme, theme.PrimaryColor)} inset`,
        color: ({ theme }) =>
            backgroundless(theme)
                ? theme.PrimaryColor
                : Mixins.foregroundColor(theme, theme.PrimaryColor),
        composes: "choice--selected",
    },
    choiceHover: {
        composes: "choice--hover",
        background: ({ theme, selected }) => {
            if (backgroundless(theme)) return undefined;
            return selected
                ? Mixins.darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                : Mixins.darken(theme.ControlBackground, theme.ActiveHighlightValue);
        },
        boxShadow: ({ theme, selected }) =>
            `0 0 0 ${theme.BorderWidth}px ${Mixins.borderColor(
                theme,
                selected
                    ? Mixins.darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                    : Mixins.darken(theme.ControlBackground, theme.ActiveHighlightValue),
            )} inset`,
    },
    choiceActive: {
        composes: "choice--active",
        background: ({ theme, selected }) => {
            if (backgroundless(theme)) return undefined;
            return selected
                ? Mixins.darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                : Mixins.darken(theme.ControlBackground, theme.ActiveHighlightValue);
        },
        outlineColor: ({ theme }) => backgroundless(theme) && theme.PrimaryColor,
    },
});
